import React from "react";
import Modal from "react-bootstrap/Modal";

const ResponseModal = (props: any): JSX.Element => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className="text-center">
          <h4>{props.ModalContent}</h4>

          <div className="btn btn-secondary mt-4" onClick={props.onHide}>
            ok.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResponseModal;
